import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Form, TextArea } from 'semantic-ui-react';
import Styled from 'styled-components';
import { Column, SpanCentered, StyledLabel } from 'components/Layout';
import { SingleSelect } from '../../Forms/UI/Select';
import { CheckBox } from '../../Forms/UI/Input';
import ErrorMessage from '../../Forms/UI/ErrorMessage';

const SkinnyRow = Styled(Grid.Row)`
  padding: 0 !important;
`;

const SkinnyColumn = Styled(Grid.Column)`
`;

export const BaseForm = ({ ...props }) => (
  <Form autoComplete="off" onSubmit={props.handleSubmit} loading={props.isSubmitting}>
    <Grid>
      <Column width={16} key="messaggio">
        <StyledLabel htmlFor="messaggio">Messaggio</StyledLabel>
        <TextArea
          value={props.values.messaggio || ''}
          onChange={({ target: t }) => props.setFieldValue(t.name, t.value)}
          label="Messaggio"
          name="messaggio"
          uppercase
          required
        />
        {props.errors.messaggio && (
          <ErrorMessage>
            {props.errors.messaggio}
          </ErrorMessage>
        )}
      </Column>
      <Column width={8} key="gravita">
        <SingleSelect
          options={[
            {
              value: 'error',
              label: 'Error',
            },
            {
              value: 'warning',
              label: 'Warning',
            },
            {
              value: 'info',
              label: 'Info',
            },
          ]}
          value={props.values.gravita}
          onChange={props.setFieldValue}
          onBlur={props.setFieldTouched}
          error={props.errors.gravita}
          touched={props.touched.gravita}
          name="gravita"
          label="Gravità"
        />
      </Column>
      <SkinnyRow>
        <SkinnyColumn width={2} key="attivo" textAlign="left" verticalAlign="middle" style={{ marginTop: 10 }}>
          <b>Attivo</b>
        </SkinnyColumn>
        <SkinnyColumn key="attivo-no" width={2} textAlign="right">
          <SpanCentered>
            <CheckBox
              labelRight
              {...props}
              label="No"
              value="0"
              name="attivo"
              type="radio"
              checked={props.values.attivo === '0'}
            />
          </SpanCentered>
        </SkinnyColumn>
        <SkinnyColumn key="attivo-si" width={2} textAlign="left" verticalAlign="middle">
          <SpanCentered>
            <CheckBox
              labelRight
              {...props}
              label="Si"
              value="1"
              name="attivo"
              type="radio"
              checked={props.values.attivo === '1'}
            />
          </SpanCentered>
        </SkinnyColumn>
      </SkinnyRow>
    </Grid>
  </Form>
);

BaseForm.propTypes = {
  isSubmitting: PropTypes.bool,
  values: PropTypes.object,
  touched: PropTypes.object,
  errors: PropTypes.object,
  handleSubmit: PropTypes.func,
  setFieldValue: PropTypes.func,
  setFieldTouched: PropTypes.func,
};

export default BaseForm;



// WEBPACK FOOTER //
// ./app/components/EditorAvvisi/Form/baseForm.js